import { EnrichmentCtx } from '@/types/enrichable';

export enum AgentURI {
  Base = '/agents',
  AgentV1 = '/v1/agents',
  AgentV2 = '/v2/agents',

  Extension = '/extension/agents',

  Cards = '/cards',
  OrderPlan = '/order-plan',
  Subscription = '/subscription',
  Suggestions = '/suggestions'
}

export interface AgentEnriched {
  context?: EnrichmentCtx;
  legalForm?:
    | 'abstract_partnership'
    | 'association'
    | 'body_corporate'
    | 'company_limited_by_shares'
    | 'cooperative'
    | 'foundation'
    | 'general_partnership'
    | 'institute'
    | 'limited_liability_company'
    | 'limited_partnership'
    | 'natural_person'
    | 'ownership_in_undivided_shares'
    | 'partnership_limited_by_shares'
    | 'public_cooperative'
    | 'public_corporation_limited_by_shares'
    | 'public_institution'
    | 'registered_couple'
    | 'simple_partnership'
    | 'sole_proprietorship'
    | 'special_legal_form';
  name?: string;
  status?:
    | 'bankable'
    | 'cancelled'
    | 'identified'
    | 'new'
    | 'passive'
    | 'registered'
    | 'rejected'
    | 'retired'
    | 'screened';
  uid?: string;
}
